import Vue from 'vue';
import Vuex from 'vuex';
//import { Auth } from "aws-amplify";
import auth from './vuex/auth';
import user from './vuex/user';
import store from './vuex/store';
import doheader from './vuex/doheader';
import doitem from './vuex/doitem';
import schedule from './vuex/schedule';
import load from './vuex/load';
import billOfLoad from './vuex/billOfLoad';
import callLogs from './vuex/callLogs';
import yardQc from './vuex/yardQc';
import ccicApplication from './vuex/ccicApplication';
import ccicContainer from './vuex/ccicContainer';
import punch from './vuex/punch';
import loadList from './vuex/loadList';
import yardExportList from './vuex/yardExport';
import truckLoad from './vuex/truckLoad';
import importLoad from './vuex/importLoad';
import directExport from './vuex/directExport';
import gstLoad from './vuex/gstLoad';
import gstStage from './vuex/gstStage';
import gstPrice from './vuex/gstPrice';
import gstDriverMaster from './vuex/gstDriverMaster';
import fsiDriverMaster from './vuex/fsiDriverMaster';
import reminder from './vuex/reminder';
import billOfLoadWithProblem from './vuex/billOfLoadWithProblem';
import inbound from './vuex/inbound';
import outbound from './vuex/outbound';
import outboundList from './vuex/outboundList';
import ibsinbound from './vuex/ibsinbound';
import ibsoutbound from './vuex/ibsoutbound';
import ibslist from './vuex/ibslist';
import stcSMSLog from './vuex/stcSMSLog';
import ccrLog from './vuex/ccrLog';
import fsidailyreport from './vuex/fsidailyreport';
import stcDriverGroup from './vuex/stcDriverGroup';
import dispatchStageList from './vuex/dispatchStage';
//import api from './api';
import { newAPIPost } from './api';
import config from './config';
import lockload from './vuex/lockload';
import lockstage from './vuex/lockstage';
import lockchassis from './vuex/lockchassis';
import stageCostMass from './vuex/stageCostMass';
import payrollSettle from './vuex/payrollSettle';
import payrollReport from './vuex/payrollReport';
import versionApp from './vuex/versionApp';
import userLocation from './vuex/userLocation'
import inboundUnmatchRpt from './vuex/fsiInboundUnmatchRpt'
import userReportLayout from './vuex/reportLayout'
import { getCurrentUser } from 'aws-amplify/auth';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth,
    user,
    store,
    doheader,
    doitem,
    schedule,
    load,
    billOfLoad,
    callLogs,
    yardQc,
    ccicApplication,
    ccicContainer,
    punch,
    billOfLoadWithProblem,
    reminder,
    loadList,
    yardExportList,
    dispatchStageList,
    truckLoad,
    importLoad,
    directExport,
    gstLoad,
    gstStage,
    gstPrice,
    gstDriverMaster,
    fsiDriverMaster,
    inbound,
    outbound,
    outboundList,
    ibsinbound,
    ibsoutbound,
    ibslist,
    fsidailyreport,
    stcSMSLog,
    stcDriverGroup,
    ccrLog,
    lockload,
    lockstage,
    lockchassis,
    stageCostMass,
    payrollSettle,
    payrollReport,
    versionApp,
    userLocation,
    inboundUnmatchRpt,
    userReportLayout
  },
  state: {
    globalError: null,
    callingApis: [],
    apiErrorResponses: [],
    masterDataNameMap: {},
    masterDataGroupMap: {},
    masterDataParentGroupMap: {},
    userProfile: null,
  },
  mutations: {
    updateGlobalError(state, err) {
      state.globalError = err;
    },
    clearApiError(state) {
      state.apiErrorResponses = [];
    },
    updateApiError(state, { apiPath, errorRes }) {
      const find = _(state.apiErrorResponses)
        .find(it => it.apiPath === apiPath);
      if (find) {
        find.errorRes = errorRes;
      } else {
        state.apiErrorResponses.push({
          apiPath,
          errorRes,
        });
      }
    },
    updateCallingApi(state, { apiPath, calling }) {
      const find = _(state.callingApis)
        .find(it => it.apiPath === apiPath);
      if (find) {
        if (calling) {
          find.calling += 1;
        } else {
          find.calling -= 1;
        }
        if (find.calling < 0) {
          find.calling = 0;
        }
      } else if (calling) {
        state.callingApis.push({
          apiPath,
          calling: 1,
        });
      }
    },
    updateMasterDatas(state, masterDatas) {
      const filteredMasterDatas = _(masterDatas)
        .filter(it => !!it.active)
        .map((it) => {
          const {
            group, 
            tagId, 
            tagName, 
            parentTagId, 
            parentGroup, 
            measureUnit,
            weight,
            diffTolerance,
            recWindow,
            location,
            warnToleranceTime,
            errToleranceTime,
            gradeUpgrade,
            grade,
            extTrucker,
            to,
            from,
            chassisVendorType,
            address,
            contactPerson,
            contactTel,
            amtScaleDeduction1,
            amtScaleAddition1,
            amtParkingDeduction1,
            amtParkingAddition1,
            amtManifestDeduction1,
            amtManifestAddition1,
            amtInsuranceDeduction1,
            amtInsuranceAddition1,
            active
          } = it;
          return {
            group,
            tagId,
            tagName,
            parentTagId,
            parentGroup,
            id: tagId,
            name: tagName,
            unit: measureUnit,
            weight,
            diffTolerance,
            recWindow,
            location,
            errToleranceTime,
            warnToleranceTime,
            gradeUpgrade,
            grade,
            extTrucker,
            to,
            from,
            chassisVendorType,
            address,
            contactPerson,
            contactTel,
            amtScaleDeduction1,
            amtScaleAddition1,
            amtParkingDeduction1,
            amtParkingAddition1,
            amtManifestDeduction1,
            amtManifestAddition1,
            amtInsuranceDeduction1,
            amtInsuranceAddition1,
            active
          };
        });
      const masterDataNameMap = {};
      const masterDataGroupMap = {};
      const masterDataParentGroupMap = {};
      _(filteredMasterDatas)
        .chain()
        .groupBy(it => it.group)
        .each((values, group) => {
          const groupValues = {};
          _(values)
            .each((m) => {
              const {
                tagId, tagName,
              } = m;
              groupValues[tagId] = tagName;
            });
          masterDataNameMap[group] = groupValues;
          masterDataGroupMap[group] = values;
        });

      _(filteredMasterDatas)
        .chain()
        .filter(it => !!it.parentGroup)
        .groupBy(it => it.parentGroup)
        .each((values, parentGroup) => {
          masterDataParentGroupMap[parentGroup] = values;
        });

      state.masterDataNameMap = masterDataNameMap;
      state.masterDataGroupMap = masterDataGroupMap;
      state.masterDataParentGroupMap = masterDataParentGroupMap;
    },
    updateUserProfile(state, userProfile) {
      state.userProfile = userProfile;
    },
  },
  actions: {

    //async handleUserLoggedIn({ commit }, username) {
    async handleUserLoggedIn({ commit, dispatch }, username) {

      console.log("Start handleuserloggedin " + Date())

/*      
      const grouplist = await api.post('/api/w/masterData/getGroupList');
      var masterDataGroup = [];
      var newMasterDataBatch = [];
      //var masterDataGroupList = JSON.stringify(grouplist).toString();
      $.each( grouplist , function(key, value) {
           value = JSON.stringify(value);
           value = value.toString().substring(value.toString().indexOf(':')+1).replaceAll('"','').replaceAll('}','');
           masterDataGroup.push(value)
      }
      );
      const totalGroups = masterDataGroup.length;
      console.log("grouplist: " + masterDataGroup + " count: " + totalGroups);
      var startindx = 0;
      var portion = totalGroups;
      var lastbatch = 0;
      if (totalGroups > 20)
      {
         portion = parseInt( portion / 20 ,10);
         lastbatch = totalGroups - (portion * 20);
      }
      else
      {
         //portion = parseInt( totalGroups / 20 , 10);
         portion = 0;
         lastbatch = totalGroups;
      }
      var masterDatas = [];
      var endIndx = 0;
      var i;
      console.log("handleUserLoggedIn portion: " + portion);
      if (portion > 0)
      {
        
         for (i = 1; i <= portion; i++)
         {
            console.log("startindx: " + startindx + "i: " + i);
            if (i * 20 > totalGroups)
            {
               endIndx = (i * 20) - 1;
            }
            else
            {
               endIndx = i * 20;
            }
            newMasterDataBatch = await api.post('/api/w/masterData',
             {groups: masterDataGroup.slice(startindx, endIndx)  }
            );
            startindx = (i * 20);
            masterDatas = masterDatas.concat(newMasterDataBatch);
         }
         if (lastbatch > 0)
         {
            console.log("startindx: " + startindx + " totalGroups: " + totalGroups);
            newMasterDataBatch = await api.post('/api/w/masterData',
             {groups: masterDataGroup.slice(startindx, totalGroups)  }
            );
            masterDatas = masterDatas.concat(newMasterDataBatch);
         
         }
        
         newMasterDataBatch = await api.post('/api/w/masterData', {groups: masterDataGroup.slice(0, 20)  })
         masterDatas = masterDatas.concat(newMasterDataBatch);
        }
      else
      {
         if (totalGroups > 0)
         {
            console.log("load data with portion less than or equal 0")
            masterDatas = await api.post('/api/w/masterData', {groups:masterDataGroup});
         }
      }
      //add SUPPLIER_US separately since it too large with above
      
      newMasterDataBatch = await api.post('/api/w/masterData',
      {groups: ["SUPPLIER_US"]  }
      );
      masterDatas = masterDatas.concat(newMasterDataBatch);
      
      commit('updateMasterDatas', masterDatas);
*/


/*  comment out to remove duplication call for getting master data
      const mainData = await api.post('/api/w/masterData',{groups:[
        "APP_MASTER",
        "SCALE_MASTER",
        "YG_MASTER",
        "UPGRADE_MASTER",
        "OUTBOUND_GRADE",
        "WEIGHT_CONTROL",
        "Company",
        "Country",
        "DRIVER_TYPE",
        "GST_CARRIER",
        "GST_CHASSIS",
        "GST_CTNRTYPE",
        "GST_CUSTOMER",
        "GST_DELIVERYTYPE",
        "GST_DO_STATUS",
        "GST_DO_PROCESS",
        "GST_LEASECHASSIS",
        "GST_LIC_TYPE",
        "GST_LOAD_STATUS",
        "GST_LOCATION",
        "GST_MED_TEST_TYPE",
        "GST_RATE_BILLING",
        "GST_RATE_COST",
        "GST_ROUTE",
        "GST_SALEOFFICE",
        "GST_SOURCE",
        "GST_STAGE_STATUS",
        "GST_STAGE_TYPE",
        "GST_STATUS",
        "GST_TERMINAL",
        "GST_TRUCK",
        "UserCategory",
        "Sort",
        "State",
        "REC_WINDOW",
        "DOCKTYPE",
        "INBOUND_STATUS",
        "IBS_TYPE",
        "DriverGroup",
        "LOAD_IN_TYPE",
        "LOAD_OUT_TYPE",
        "LOAD_CTNRTYPE",
        //"LOADOUTTRANSTYPE",
        "DELIVER_LOC",
        "LOADINTRANSTYPE",
        "STC_DO_STATUS",
        "STC_CARRIER",
        "CCIC_ROLE",
        "CCIC_SUPPLIER_GROUPS",
        "CCR_CNTRTYPE",
        "CCR_CNTRTYPE_ID",
        "STC_STAGE_TYPE",
        "PUSH_STATUS",
        "STC_COSTREL_STATUS",
        "STC_FREIGHT_TYPE",
        "STC_CHASSIS_VENDOR",
        "STC_TERMINAL",
        "STC_LOAD_STAGES_YY",
        "STC_LOAD_STAGES_YE",
        "STC_LOAD_STAGES_YI",
        "STC_LOAD_STAGES_YT",
        "STC_DO_STATUS",
        "STC_CUSTOMER",
        "STC_VENDOR",
        "CCR_STATUSTYPE",
        "CCR_CNTRTYPE",
        "CCR_GATETYPE",
        "CCR_STATUS2",
        "CCR_CNTRSIZE",
        "CCR_CNTRTYPE_ID",
        "STC_PAYTERM"
    ]})
        // .then((masterDatas) => {
        //   commit('updateMasterDatas', masterDatas);
        // });

    const batch1 =  await api.post('/api/w/masterData',{groups:[
      "CCIC_TEAM",
  ]})
      // .then((masterDatas) => {
      //   commit('updateMasterDatas', masterDatas);
      // });

      commit('updateMasterDatas', mainData.concat(batch1));
     */
      //dispatch('loadMasterData');
      //console.log("loadmasterData: " + dispatch('loadMasterData'));

      //api.post("/api/w/users/me", { username })
      await newAPIPost("/api/w/users/me", { username })
        .then((userProfile) => {
          commit('updateUserProfile', userProfile);
          console.log("update user profile with userprofile: " + JSON.stringify(userProfile));
          console.log("loadmasterData: " + dispatch('loadMasterData'));
        });
    },
    async refreshUserProfile({ commit }) {
      //const cognitoUser = await Auth.currentAuthenticatedUser();
      const cognitoUser = await getCurrentUser();
      //api.post("/api/w/users/me", { username: cognitoUser.username })
      await newAPIPost("/api/w/users/me", { username: cognitoUser.username })
        .then((userProfile) => {
          commit('updateUserProfile', userProfile);
        });
    },

   
    
    async loadMasterData({ commit }) {

      console.log("getuserprofile in store: " + JSON.stringify(this.state.userProfile));
      console.log("user category: " + this.state.userProfile.category);
      console.log("Start loadMasterData " + Date());
      var masterdataoffice = "ALL";
      if (this.state.userProfile) {
         if (this.state.userProfile.category === "R"|| this.state.userProfile.category === "U" || this.state.userProfile.category === "U1"
             || this.state.userProfile.category === "U2") 
            masterdataoffice = "STC";
      }   
      if (this.state.userProfile) {
         if (this.state.userProfile.category === "Q" ||
             this.state.userProfile.category === "O" ||
             this.state.userProfile.category === "P" ||
             this.state.userProfile.category === "V" ||
             this.state.userProfile.category === "V1" ||
             this.state.userProfile.category === "V2" ||
             this.state.userProfile.category === "W" ||
             this.state.userProfile.category === "Y" ||
             this.state.userProfile.category === "Y1" ||
             this.state.userProfile.category === "Y2" 
         )
           masterdataoffice = "FSI";
      }
      //const grouplist = await api.post('/api/w/masterData/getGroupList',{office: masterdataoffice, active: 1});//.then
      const grouplist = await newAPIPost('/api/w/masterData/getGroupList',{office: masterdataoffice, active: 1});
      //{
      var masterDataGroup = [];
      var newMasterDataBatch = [];
      //var masterDataGroupList = JSON.stringify(grouplist).toString();
      console.log("grouplist: " + JSON.stringify(grouplist));
      $.each( grouplist , function(key, value) {
           value = JSON.stringify(value);
           value = value.toString().substring(value.toString().indexOf(':')+1).replaceAll('"','').replaceAll('}','');
           masterDataGroup.push(value)
      }
      );
      const totalGroups = masterDataGroup.length;
      console.log("grouplist: " + masterDataGroup + " count: " + totalGroups);
      var startindx = 0;
      var portion = totalGroups;
      var lastbatch = 0;
      if (totalGroups > 20)
      {
         portion = parseInt( portion / 20 ,10);
         lastbatch = totalGroups - (portion * 20);
      }
      else
      {
         //portion = parseInt( totalGroups / 20 , 10);
         portion = 0;
         lastbatch = totalGroups;
      }
      var masterDatas = [];
      var endIndx = 0;
      var i;
      console.log("loadMasterData portion: " + portion);
      if (portion > 0)
      {
         for (i = 1; i <= portion; i++)
         {
            console.log("startindx: " + startindx + "i: " + i);
            if (i * 20 > totalGroups)
            {
               endIndx = (i * 20) - 1;
            }
            else
            {
               endIndx = i * 20;
            }
           //newMasterDataBatch = await api.post('/api/w/masterData',
            newMasterDataBatch = await newAPIPost('/api/w/masterData',
             {groups: masterDataGroup.slice(startindx, endIndx)  }
            );
            startindx = (i * 20);
            masterDatas = masterDatas.concat(newMasterDataBatch);
         }
         if (lastbatch > 0)
         {
            console.log("startindx: " + startindx + " totalGroups: " + totalGroups);
            //newMasterDataBatch = await api.post('/api/w/masterData',
            newMasterDataBatch = await newAPIPost('/api/w/masterData',
             {groups: masterDataGroup.slice(startindx, totalGroups)  }
            );
            masterDatas = masterDatas.concat(newMasterDataBatch);
         
         }
      }   
      else
      {
          console.log("load data with portion less than or equal 0")
          if (totalGroups > 0)
          {
             //masterDatas = await api.post('/api/w/masterData', {groups: masterDataGroup});
             masterDatas = await newAPIPost('/api/w/masterData', {groups: masterDataGroup});
          }
      }

      //add SUPPLIER_US since this group too large to set in above
      // newMasterDataBatch = await api.post('/api/w/masterData',
      // {groups: ["SUPPLIER_US"]  }
      // );
      // masterDatas = masterDatas.concat(newMasterDataBatch);


      commit('updateMasterDatas', masterDatas);

      return masterDatas;
    //}

/*      
      return api.post('/api/w/masterData',{groups:[
        "APP_MASTER",
        "SCALE_MASTER",
        "YG_MASTER",
        "UPGRADE_MASTER",
        "WEIGHT_CONTROL",
        "Company",
        "Country",
        "DRIVER_TYPE",
        "GST_CARRIER",
        "GST_CHASSIS",
        "GST_CTNRTYPE",
        "GST_CUSTOMER",
        "GST_DELIVERYTYPE",
        "GST_DO_STATUS",
        "GST_LEASECHASSIS",
        "GST_LIC_TYPE",
        "GST_LOAD_STATUS",
        "GST_LOCATION",
        "GST_MED_TEST_TYPE",
        "GST_RATE_BILLING",
        "GST_RATE_COST",
        "GST_ROUTE",
        "GST_SALEOFFICE",
        "GST_SOURCE",
        "GST_STAGE_STATUS",
        "GST_STAGE_TYPE",
        "GST_STATUS",
        "GST_TERMINAL",
        "GST_TRUCK",
        "UserCategory",
        "Sort",
        "State",
        "REC_WINDOW",
        "DOCKTYPE",
        "INBOUND_STATUS",
        "IBS_TYPE",
        "driverGroup"
      ]}
      )
        .then((masterDatas) => {
          commit('updateMasterDatas', masterDatas);
        });
*/
        
    },
    updateMasterDataGroup(_, updateMasterDataGroupRequest) {
      console.log("updateMasterDataGroupRequest: " + JSON.stringify(updateMasterDataGroupRequest));
      //return api.post('/api/w/masterData/createGroupList', updateMasterDataGroupRequest);
      return newAPIPost('/api/w/masterData/createGroupList', updateMasterDataGroupRequest);
    }, 
    updateMasterData({ dispatch }, updateMasterDataRequest) {
      //return api.post('/api/w/masterData/update', updateMasterDataRequest)
      return newAPIPost('/api/w/masterData/update', updateMasterDataRequest)
        .then(() => {
          dispatch('loadMasterData');
        });
    },
    generateExcel(_, request) {
      //return api.post('/api/w/excel/generate', request);
      return newAPIPost('/api/w/excel/generate', request);
    },
  },
  getters: {
    getMasterDataName: state =>
      (group, tagId) => _(state.masterDataNameMap)
        .lookup(`${group}.${tagId}`),
    getMasterDataByGroup: state => group => (state.masterDataGroupMap[group]) || [],
    flatWithChildDriverGroups: (state, getters) =>
      (driverGroups) => {
        const allDriverGroups = getters.getMasterDataByGroup('DriverGroup');
        const childDriverGroups = _(driverGroups)
          .chain()
          .map(parent => _(allDriverGroups)
            .filter(it => it.parentTagId === parent))
          .flatten()
          .map(it => it.tagId)
          .value();

        return _(driverGroups)
          .chain()
          .union(childDriverGroups)
          .uniq()
          .value();
      },
    getMasterDataAsSelectOptionByGroup: (state, getters) =>
      group => getters.getMasterDataByGroup(group),
    getSaleOfficeMasterData: (state, getters) => {
//      const salesoffice = getters.getMasterDataByGroup('GST_SALEOFFICE')
//      .map((it) => {
//        const {
//          tagId, tagName,
//        } = it;
//        return {
//          tagName,
//        };
//      });
//      return salesoffice;
      //      return salesoffice.tagId;
        return getters.getMasterDataByGroup('GST_SALEOFFICE')
        .map(it => it.tagName)
    },
    getSaleOfficeByName: (state,getters) => (saleoffice) => {
        return getters.getMasterDataByGroup('GST_SALEOFFICE')
             .filter(it => it.tagName == saleoffice)
             //.map(it => it.tagId)
    },
    getNonSTCRecWindow: (state,getters) => () => {
        return getters.getMasterDataByGroup('REC_WINDOW')
             .filter(it => it.tagName != 'STC')
    },
    getMasterDataByParentGroupAndTagId: (state) => (parentGroup, parentTagId) =>
      state.masterDataParentGroupMap[parentGroup].filter(it.parentTagId === parentTagId),
    getUserProfile: state => state.userProfile,
    getDriverGroupOptionsForUser: (state, getters) => {
      const driverGroups = getters.getMasterDataByGroup('DriverGroup');
      if (getters.getRole.isDispatcher) {
        const userDriverGroup = getters.getUserProfile.driverGroup;
        return _(driverGroups)
          .filter(it => it.tagId === userDriverGroup || it.parentTagId === userDriverGroup);
      }
      return driverGroups;
    },
    getBillRateByCategory: (state, getters) => (category) => {
       return getters.getMasterDataByGroup("GST_RATE_COST").filter( it => it.extTrucker === category);
    },
    getRole: (state) => {
      const isDriver = !!state.userProfile && state.userProfile.category === 'A';
      const isDispatcher = !!state.userProfile && state.userProfile.category === 'B';
      const isYard = !!state.userProfile && state.userProfile.category === 'C';
      const isAcn = !!state.userProfile && state.userProfile.category === 'D';
      const isAcnIT = !!state.userProfile && state.userProfile.category === 'E';
      const isAcnQC = !!state.userProfile && state.userProfile.category === 'F';
      const isCcicQc = !!state.userProfile && state.userProfile.category === 'G';
      const isCcicQc3rdParty = !!state.userProfile && state.userProfile.category  === 'G1';
      const isCcicQcWithExco = !!state.userProfile && state.userProfile.category  === 'G2';
      const isFSIAC1 = !!state.userProfile && state.userProfile.category === 'O';
      const isFSIAC2 = !!state.userProfile && state.userProfile.category === 'P';
      const isFSI = !!state.userProfile && state.userProfile.category === 'Q';
      const isSTC = !!state.userProfile && state.userProfile.category === 'R';
      const isSTCWithPM = !!state.userProfile && state.userProfile.category === 'R1';
      const isMkt1 = !!state.userProfile && state.userProfile.category === 'S';
      const isMkt2 = !!state.userProfile && state.userProfile.category === 'T';
      const isSTCDO = !!state.userProfile && state.userProfile.category === 'U';
      const isSTCMgt = !!state.userProfile && state.userProfile.category === 'U1';
      const isSTCMgtLock = !!state.userProfile && state.userProfile.category == 'U1A';
      const isSTCAcct = !!state.userProfile && state.userProfile.category === 'U2';
      const isSTCAcctFSIReadOnly = !!state.userProfile && state.userProfile.category === 'U3';
      const isSTCMgtPWReset = !!state.userProfile && state.userProfile.category === 'U4';
      const isFSIClerk = !!state.userProfile && state.userProfile.category === 'V';
      const isFSIMgt = !!state.userProfile && state.userProfile.category === 'V1';
      const isFSIMgtWithRemark = !!state.userProfile && state.userProfile.category === 'V2';
      const isFSIReadOnly = !!state.userProfile && state.userProfile.category === 'W';
      const isFSIReadOnlyForERL = !!state.userProfile && state.userProfile.category === 'Y';
      const isFSIClerkWithLoadPic = !!state.userProfile && state.userProfile.category === 'Y1';
      const isFSIReadOnlyWithWgtTicket = !!state.userProfile && state.userProfile.category === 'Y2';
      const isSTCFSIReadOnlyForERL = !!state.userProfile && state.userProfile.category === 'Y3';
      const isSTCFSIReadOnlyForERLMgt = !!state.userProfile && state.userProfile.category === 'Y4';
      const isSTCDriver = !!state.userProfile && state.userProfile.category === 'A1';
      const isSTCOptFSIReadOnly = !!state.userProfile && state.userProfile.category === 'W1';
      const isSTCAudit = !!state.userProfile && state.userProfile.category === 'W2';
      const isSTCMgtFSIReadOnly = !!state.userProfile && state.userProfile.category === 'W3';
      const isSTCLoadListUpdate = !!state.userProfile && state.userProfile.category === 'X1';
      const isSTCReadOnlyWithLoadListUpdate = !!state.userProfile && state.userProfile.category === 'X2';


      return {
        isDriver,
        isSTCDriver,
        isDispatcher,
        isYard,
        isAcn,
        isAcnIT,
        isAcnQC,
        isCcicQc,
        isCcicQc3rdParty,
        isCcicQcWithExco,
        isFSIAC1,
        isFSIAC2,
        isFSI,
        isSTC,
        isSTCWithPM,
        isSTCMgt,
        isSTCMgtLock,
        isSTCAcct,
        isSTCAcctFSIReadOnly,
        isMkt1,
        isMkt2,
        isSTCDO,
        isFSIClerk,
        isFSIMgt,
        isFSIMgtWithRemark,
        isFSIReadOnly,
        isFSIReadOnlyForERL,
        isSTCFSIReadOnlyForERL,
        isSTCFSIReadOnlyForERLMgt,
        isFSIClerkWithLoadPic,
        isFSIReadOnlyWithWgtTicket,
        isSTCOptFSIReadOnly,
        isSTCAudit,
        isSTCMgtFSIReadOnly,
        isSTCMgtPWReset,
        isSTCLoadListUpdate,
        isSTCReadOnlyWithLoadListUpdate,
      };
    },
    getPermission: (state, getters) => {
      const {
        isDispatcher,
        isYard,
        isAcn,
        isAcnIT,
        isAcnQC,
        isCcicQc,
        isCcicQc3rdParty,
        isCcicQcWithExco,
        isFSIAC1,
        isFSIAC2,
        isFSI,
        isSTC,
        isSTCWithPM,
        isSTCMgt,
        isSTCMgtLock,
        isSTCAcct,
        isSTCAcctFSIReadOnly,
        isMkt1,
        isMkt2,
        isSTCDO,
        isFSIClerk,
        isFSIMgt,
        isFSIMgtWithRemark,
        isFSIReadOnly,
        isFSIReadOnlyForERL,
        isSTCFSIReadOnlyForERL,
        isSTCFSIReadOnlyForERLMgt,
        isFSIClerkWithLoadPic,
        isFSIReadOnlyWithWgtTicket,
        isSTCOptFSIReadOnly,
        isSTCAudit,
        isSTCMgtFSIReadOnly,
        isSTCMgtPWReset,
        isSTCLoadListUpdate,
        isSTCReadOnlyWithLoadListUpdate,
      } = getters.getRole;
      const canEditCcic = getters.getUserProfile && getters.getUserProfile.ccicReadOnly !== true;
      const { env } = config;
      const inPrd = env === 'prd__';
      console.log("stc do: " + isSTCDO);
      return {
        users: {
          view: isAcnIT,
          edit: isAcnIT,
        },
        stores: {
          view: isAcnIT || isAcn || isAcnQC || isMkt1 || isMkt2,
          edit: isAcn || isMkt1 || isMkt2 || (isAcnIT && !inPrd),
        },
        do:{

          view: isAcnIT || isSTC || isFSIAC1 || isSTCDO || isSTCMgt || isSTCAcct || isSTCAcctFSIReadOnly || isSTCWithPM 
                  || isSTCMgtFSIReadOnly || isSTCAudit || isSTCAcctFSIReadOnly || isSTCMgtLock
                  || isSTCMgtPWReset,

          edit: isAcnIT || isSTC || isFSIAC1 || isSTCDO || isSTCMgt || isSTCMgtLock || isSTCMgtPWReset,
        },
        doReadOnly:{
          view: isCcicQcWithExco || isSTCFSIReadOnlyForERL || isSTCFSIReadOnlyForERLMgt,
        },
        si:{
          view: isAcnIT || isFSIAC1 || isSTCDO || isSTC || isSTCMgt || isSTCMgtFSIReadOnly 
                  || isSTCAudit || isSTCAcctFSIReadOnly || isSTCMgtPWReset
                  || isSTCMgtLock,
          edit: isAcnIT || isFSIAC1 || isSTCDO || isSTC || isSTCMgt || isSTCMgtPWReset
                || isSTCMgtLock,
        },      
        schedules: {
          view: isDispatcher || isAcnIT || isAcn || isAcnQC || isMkt1 || isMkt2,
          edit: isDispatcher || (isAcnIT && !inPrd),
        },
        loads: {
          view: isDispatcher || isAcnIT || isAcn || isAcnQC || isMkt1 || isMkt2,
          edit: isDispatcher || (isAcnIT && !inPrd),
        },
        callLogs: {
          view: isAcnIT || isAcn || isMkt1 || isMkt2,
          edit: isAcn || isMkt1 || isMkt2 || (isAcnIT && !inPrd),
        },
        yardQc: {
          view: isYard || isAcnIT || isAcn || isAcnQC || isMkt1 || isMkt2,
          edit: isYard || isAcnQC || (isAcnIT && !inPrd),
        },
        ccic: {
          view: isCcicQc || isCcicQc3rdParty || isCcicQcWithExco || isAcnIT || isAcn || isMkt1 || isMkt2,
          edit: (isCcicQc || isCcicQc3rdParty || isCcicQcWithExco || isAcnIT || isAcn || isMkt1 || isMkt2) && canEditCcic,
        },
        settings: {
          view: isAcnIT,
          edit: isAcnIT,
        },
        ibslist: {

          view: isFSIAC1 || isFSIAC2 || isFSI || isFSIClerk || isFSIMgt || isFSIMgtWithRemark || isMkt1 || isMkt2 || isAcnIT || isFSIReadOnly || isFSIReadOnlyForERL 
                         || isSTCFSIReadOnlyForERL || isSTCFSIReadOnlyForERLMgt || isFSIClerkWithLoadPic || isFSIReadOnlyWithWgtTicket || isSTCOptFSIReadOnly || isSTCMgtFSIReadOnly 
                         || isSTCAudit || isSTCAcctFSIReadOnly,
          edit: isFSIAC1 || isFSIAC2 || isFSI || isFSIClerk || isFSIMgt || isFSIMgtWithRemark || isMkt1 || isMkt2 || isAcnIT || isFSIReadOnly || isFSIReadOnlyForERL 
                         || isSTCFSIReadOnlyForERL || isSTCFSIReadOnlyForERLMgt || isFSIClerkWithLoadPic || isFSIReadOnlyWithWgtTicket || isSTCOptFSIReadOnly || isSTCMgtFSIReadOnly 
                         || isSTCAudit || isSTCAcctFSIReadOnly,
        },
        ibslistob: {

          view: isFSIAC1 || isFSIAC2 || isFSI || isFSIClerk || isFSIMgt || isFSIMgtWithRemark || isMkt1 || isMkt2 || isAcnIT || isFSIReadOnly || isFSIReadOnlyForERL 
                         || isSTCFSIReadOnlyForERL || isSTCFSIReadOnlyForERLMgt || isFSIClerkWithLoadPic || isFSIReadOnlyWithWgtTicket || isSTCOptFSIReadOnly || isSTCMgtFSIReadOnly 
                         || isSTCAudit || isSTCAcctFSIReadOnly || isSTCAcct || isSTCMgtLock,
          edit: isFSIAC1 || isFSIAC2 || isFSI || isFSIClerk || isFSIMgt || isFSIMgtWithRemark || isMkt1 || isMkt2 || isAcnIT || isFSIReadOnly || isFSIReadOnlyForERL 
                         || isSTCFSIReadOnlyForERL || isSTCFSIReadOnlyForERLMgt || isFSIClerkWithLoadPic || isFSIReadOnlyWithWgtTicket || isSTCOptFSIReadOnly || isSTCMgtFSIReadOnly 
                         || isSTCAudit || isSTCAcctFSIReadOnly,
        },
        ibslist3p: {

          view: isFSIAC1 || isFSIAC2 || isFSI || isFSIClerk || isFSIMgt || isFSIMgtWithRemark || isMkt1 || isMkt2 || isAcnIT || isFSIReadOnly || isFSIReadOnlyForERL 
                         || isSTCFSIReadOnlyForERL || isSTCFSIReadOnlyForERLMgt || isFSIClerkWithLoadPic || isFSIReadOnlyWithWgtTicket || isSTCOptFSIReadOnly || isSTCMgtFSIReadOnly 
                         || isSTCAudit || isSTCAcctFSIReadOnly || isSTCMgtLock || isSTCMgtLock
                         || isSTCAcct,
          edit: isFSIAC1 || isFSIAC2 || isFSI || isFSIClerk || isFSIMgt || isFSIMgtWithRemark || isMkt1 || isMkt2 || isAcnIT
                         || isFSIClerkWithLoadPic,
        },
        opcockpiti: {
          view: isFSI || isFSIClerk || isFSIMgt || isFSIMgtWithRemark || isMkt2 || isAcnIT || isFSIReadOnly || isFSIReadOnlyForERL || isSTCFSIReadOnlyForERL || isSTCFSIReadOnlyForERLMgt || isFSIClerkWithLoadPic || isFSIReadOnlyWithWgtTicket || isSTCOptFSIReadOnly || isSTCOptFSIReadOnly || isSTCMgtFSIReadOnly || isSTCAudit || isSTCAcctFSIReadOnly
                || isSTCReadOnlyWithLoadListUpdate,
          edit: isFSI || isFSIClerk || isFSIMgt || isFSIMgtWithRemark || isMkt2 || isAcnIT || isFSIReadOnly || isFSIReadOnlyForERL || isSTCFSIReadOnlyForERL || isSTCFSIReadOnlyForERLMgt || isFSIClerkWithLoadPic || isFSIReadOnlyWithWgtTicket || isSTCOptFSIReadOnly || isSTCOptFSIReadOnly || isSTCMgtFSIReadOnly || isSTCAudit || isSTCAcctFSIReadOnly
                || isSTCReadOnlyWithLoadListUpdate,
        },
        opcockpito: {
          view: isFSI || isFSIClerk || isFSIMgt || isFSIMgtWithRemark || isSTC || isSTCWithPM || isMkt2 || isAcnIT || isFSIReadOnly || isCcicQc || isCcicQc3rdParty || isCcicQcWithExco || isFSIReadOnlyForERL || isSTCFSIReadOnlyForERL || isSTCFSIReadOnlyForERLMgt || isSTCMgt || isFSIClerkWithLoadPic || isFSIReadOnlyWithWgtTicket || isSTCOptFSIReadOnly || isSTCMgtFSIReadOnly || isSTCAudit || isSTCAcctFSIReadOnly || isSTCMgtPWReset,
          edit: isFSI || isFSIClerk || isFSIMgt || isFSIMgtWithRemark || isSTC || isSTCWithPM || isMkt2 || isAcnIT || isFSIReadOnly || isCcicQc || isCcicQc3rdParty || isCcicQcWithExco || isFSIReadOnlyForERL || isSTCFSIReadOnlyForERL || isSTCFSIReadOnlyForERLMgt|| isSTCMgt || isFSIClerkWithLoadPic || isFSIReadOnlyWithWgtTicket || isSTCOptFSIReadOnly || isSTCMgtFSIReadOnly || isSTCAudit || isSTCAcctFSIReadOnly || isSTCMgtPWReset,
        },
        fsiac2: {
           view: isFSIAC2 || isFSI || isFSIClerk || isFSIMgt || isFSIMgtWithRemark || isFSIReadOnly || isFSIReadOnlyForERL || isSTCFSIReadOnlyForERL || isSTCFSIReadOnlyForERLMgt || isFSIClerkWithLoadPic || isFSIReadOnlyWithWgtTicket || isSTCOptFSIReadOnly || isSTCMgtFSIReadOnly || isSTCAcctFSIReadOnly
                 || isSTCReadOnlyWithLoadListUpdate,
           edit: isFSIAC2 || isFSI || isFSIClerk || isFSIMgt || isFSIMgtWithRemark || isFSIReadOnly || isFSIReadOnlyForERL || isSTCFSIReadOnlyForERL || isSTCFSIReadOnlyForERLMgt || isFSIClerkWithLoadPic || isFSIReadOnlyWithWgtTicket || isSTCOptFSIReadOnly
                 || isSTCReadOnlyWithLoadListUpdate,
        },
        mkt2: {
           view: isMkt2,
           edit: isMkt2,
        },
        fsi: {
           view: isFSI || isFSIClerk || isFSIMgt || isFSIMgtWithRemark || isFSIReadOnly || isFSIReadOnlyForERL || isSTCFSIReadOnlyForERL || isSTCFSIReadOnlyForERLMgt || isFSIClerkWithLoadPic || isFSIReadOnlyWithWgtTicket || isSTCOptFSIReadOnly || isSTCMgtFSIReadOnly || isSTCAcctFSIReadOnly
                       || isSTCReadOnlyWithLoadListUpdate,
           edit: isFSI || isFSIClerk || isFSIMgt || isFSIMgtWithRemark || isFSIReadOnly || isFSIReadOnlyForERL || isSTCFSIReadOnlyForERL || isSTCFSIReadOnlyForERLMgt || isFSIClerkWithLoadPic || isFSIReadOnlyWithWgtTicket || isSTCOptFSIReadOnly
                       || isSTCReadOnlyWithLoadListUpdate,
        },
        fsiClerk: {
           view: isAcnIT || isFSI || isFSIClerk || isFSIMgt || isFSIMgtWithRemark || isFSIClerkWithLoadPic,
           edit: isAcnIT ||isFSI || isFSIClerk || isFSIMgt || isFSIMgtWithRemark || isFSIClerkWithLoadPic
        },
        fsiMgt: {
           edit: isFSIMgt
        },
        fsiMgtWithRemark: {
           edit: isFSIMgtWithRemark
        },
        scalecontrol: {
          view: isFSIMgt || isFSIMgtWithRemark || isAcnIT,
          edit: isFSIMgt || isFSIMgtWithRemark || isAcnIT,
       },
        stc: {

           view: isAcnIT || isSTC || isSTCMgt || isSTCMgtLock || isSTCOptFSIReadOnly || isSTCAcct || isSTCAcctFSIReadOnly || isSTCWithPM || isSTCMgtFSIReadOnly || isSTCAudit || isSTCAcctFSIReadOnly || isSTCMgtPWReset || isSTCFSIReadOnlyForERL || isSTCFSIReadOnlyForERLMgt,
           edit: isAcnIT || isSTC || isSTCMgt || isSTCMgtLock || isSTCOptFSIReadOnly || isSTCAcct || isSTCAcctFSIReadOnly || isSTCWithPM || isSTCMgtFSIReadOnly || isSTCAudit || isSTCAcctFSIReadOnly || isSTCMgtPWReset,
        },
        stcWithPM: {
           view: isSTCWithPM,
           edit: isSTCWithPM,
        },
        stcClerk: {
           view: isAcnIT || isSTC || isSTCMgt || isSTCMgtLock || isSTCWithPM || isSTCMgtFSIReadOnly || isSTCMgtPWReset,
           edit: isAcnIT || isSTC || isSTCMgt || isSTCMgtLock || isSTCWithPM || isSTCMgtPWReset,

        },
        stcdo: {
           view: isSTCDO || isSTCMgt || isSTCMgtLock || isSTCMgtFSIReadOnly || isSTCMgtPWReset,
           edit: isSTCDO || isSTCMgt || isSTCMgtLock || isSTCMgtPWReset,
        },
        stcMgt: {
           view: isSTCMgt || isSTCMgtLock || isSTCMgtFSIReadOnly || isSTCMgtPWReset,
           edit: isSTCMgt || isSTCMgtLock || isSTCMgtFSIReadOnly || isSTCMgtPWReset, 
        },
        stcMgtPWReset: {
           edit: isSTCMgtPWReset,
        },
        stcAcct: {
           view: isSTCAcct || isSTCAcctFSIReadOnly,
           edit: isSTCAcct || isSTCAcctFSIReadOnly,
        },
        stcExtraCost: {
           view: isCcicQcWithExco,
           edit: isCcicQcWithExco,
        },
        acnit: {
           view: isAcnIT,
           edit: isAcnIT,
        },
        masterdata: {
          view: isAcnIT || isFSI,
          edit: isAcnIT || isFSI,
        },
        walmart: {
          view: isAcn || isAcnQC || isDispatcher || isYard || isMkt1 || isMkt2,
        },
        fsi_menu: {
          view: isFSI || isFSIClerk || isFSIMgt || isFSIMgtWithRemark || isFSIAC1 || isFSIAC2 || isMkt1 || isMkt2 || isAcnIT || isSTC || isSTCMgt || isSTCMgtLock || isSTCMgtPWReset 
                || isSTCDO || isCcicQc || isCcicQc3rdParty || isCcicQcWithExco || isAcn || isFSIReadOnly || isFSIReadOnlyForERL || isSTCFSIReadOnlyForERL || isSTCFSIReadOnlyForERLMgt || isFSIClerkWithLoadPic 
                || isFSIReadOnlyWithWgtTicket || isSTCOptFSIReadOnly
                || isSTCWithPM || isSTCAudit || isSTCMgtFSIReadOnly || isSTCAcctFSIReadOnly
                || isSTCLoadListUpdate || isSTCReadOnlyWithLoadListUpdate || isSTCAcct, 
        },

        fsireadonly: {
          view: isFSIReadOnly || isSTCOptFSIReadOnly || isSTCAudit || isSTCMgtFSIReadOnly || isSTCAcctFSIReadOnly || isSTCFSIReadOnlyForERL || isSTCFSIReadOnlyForERLMgt,

          edit: isSTCMgtFSIReadOnly
        },
        fsireadonlyforerl: {
          view: isFSIReadOnlyForERL || isSTCFSIReadOnlyForERL || isSTCFSIReadOnlyForERLMgt || isSTCReadOnlyWithLoadListUpdate,
        },
        stcfsireadonlyforerl: {
          view: isSTCFSIReadOnlyForERL || isSTCFSIReadOnlyForERLMgt,
        },
        stcfsireadonlyforerlmgt: {
          view: isSTCFSIReadOnlyForERLMgt, 
        },
        fsiclerkwithloadpic: {
          view: isFSIClerkWithLoadPic,
        },
        fsireadonlywithwgtticket: {
          view: isFSIReadOnlyWithWgtTicket,
        },
        stcoptfsireadonly: {
          view: isSTCOptFSIReadOnly,
        },
        ccicqc: {
          view: isCcicQc || isCcicQc3rdParty || isCcicQcWithExco,
        }, 
        stcreadonly: {
          view: isSTCAudit || isSTCFSIReadOnlyForERL || isSTCFSIReadOnlyForERLMgt,
        }, 
        stcMgtLock: {
          edit: isSTCMgtLock,
        },
        stcAcctLock: {
          edit: isSTCAcct || isSTCAcctFSIReadOnly,
        },
        stcloadlistupdate: {
          view: isSTCLoadListUpdate || isSTCReadOnlyWithLoadListUpdate,
        },
        stcAuditOnly: {
          view: isSTCAudit,
        } 
      };
    },
  },
});
